import { ReactNode } from 'react';

export const PageWrapperStyles = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div className="flex min-h-[100dvh] bg-dawn-blue-100 py-8 pb-20">
    <div className="mx-auto flex max-w-xl flex-1 flex-col px-4">{children}</div>
  </div>
);
